// @ts-check
import { defineConfig } from '../utils';

export function palletizing() {
  return defineConfig({
    properties: {
      'Paletizado.PaleActivo.MostrarInformacion': {
        defaultValue: false,
      },
      'Paletizado.PaleActivo.MostrarNumeroSerie': {
        defaultValue: true,
      },
      'Paletizado.PaleActivo.MostrarProducto': {
        defaultValue: true,
      },
      'Paletizado.PaleActivo.MostrarEnvase': {
        defaultValue: true,
      },
      'Paletizado.PaleActivo.MostrarPale': {
        defaultValue: true,
      },
      'Paletizado.PaleActivo.MostrarEnvasesPorPale': {
        defaultValue: true,
      },
      'Paletizado.PaleActivo.MostrarNombreCliente': {
        defaultValue: true,
      },
      'Paletizado.PaleActivo.MostrarPedidoVenta': {
        defaultValue: true,
      },
      'Paletizado.FinPale.ImprimirEtiqueta': {
        defaultValue: true,
      },
      'Paletizado.FinPale.Pesaje': {
        defaultValue: false,
      },
      'Paletizado.LecturaPale.UtilizarFlash': {
        defaultValue: true,
      },
      'Paletizado.LecturaPale.OrientacionCamaraLecturaCodigos': {
        /** @type {'landscape' | 'portrait'} */
        defaultValue: 'landscape',
      },
      'Paletizado.LecturaCajas.LecturaContinuaCodigosBarras': {
        defaultValue: false,
      },
      'Paletizado.LecturaCajas.LecturaContinuaCodigosBarrasManual': {
        defaultValue: false,
      },
      'Paletizado.LecturaCajas.UtilizarFlash': {
        defaultValue: true,
      },
      'Paletizado.LecturaCajas.OrientacionCamaraLecturaCodigos': {
        /** @type {'landscape' | 'portrait'} */
        defaultValue: 'portrait',
      },
      'Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarras': {
        defaultValue: false,
      },
      'Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarrasManual': {
        defaultValue: false,
      },
      'Paletizado.LecturaRegistroActividad.UtilizarFlash': {
        defaultValue: true,
      },
      'Paletizado.LecturaRegistroActividad.OrientacionCamaraLecturaCodigos': {
        /** @type {'landscape' | 'portrait'} */
        defaultValue: 'portrait',
      },
    },
  });
}
